module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnVpbi1zZy1jb250YWluZXIgew0KCWRpc3BsYXk6IGZsZXg7DQoJcGFkZGluZzogMC4yNXJlbSAxcmVtOw0KCWFsaWduLWl0ZW1zOiBjZW50ZXI7DQoNCgkudWluLXNnLXNlcGFyYXRvciB7DQoJCWRpc3BsYXk6IGlubGluZS1ibG9jazsNCgkJd2lkdGg6IDFweDsNCgkJaGVpZ2h0OiAxLjVyZW07DQoJCWJhY2tncm91bmQtY29sb3I6ICRncmV5LTEwMDsNCgkJbWFyZ2luOiAwIDAuMjVyZW07DQoJfQ0KfQ0K"


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/StylesGallery/StylesGallery.scss
// module id = 2496
// module chunks = 0